import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import {
  Heading,
  IFilterOption,
  FilterOption,
  BaseText,
  FilterSelect
} from '@warrenbrasil/nebraska-web';
import {
  HeaderFilterLoader,
  HeaderSubtitleLoader
} from '@/modules/trade/views/TradePositionsView/components/Loaders';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';
import {
  DerivativesFiltersDateValues,
  DerivativesFiltersTypes,
  DerivativesFiltersTypeValues,
  IDerivativesFilters
} from '../../types';
import { StringFormatted } from '@/modules/trade/types';
import { FeatureFlags } from '@/types/models/FeatureFlags';

interface Props {
  updatedAt?: string;
  isLoading?: boolean;
  filters: IDerivativesFilters;
}
type Emits = (
  event: 'on-filter-change',
  filterType: DerivativesFiltersTypes,
  filter?: DerivativesFiltersTypeValues | DerivativesFiltersDateValues
) => void;


export default /*#__PURE__*/_defineComponent({
  __name: 'DerivativesFilters',
  props: {
    updatedAt: { default: undefined },
    isLoading: { type: Boolean, default: false },
    filters: null
  },
  emits: ["on-filter-change"],
  setup(__props: any, { emit: emits }: { emit: ((
  event: 'on-filter-change',
  filterType: DerivativesFiltersTypes,
  filter?: DerivativesFiltersTypeValues | DerivativesFiltersDateValues
) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { updatedAt: string, isLoading: boolean, filters: IDerivativesFilters }




const dateOptions = computed<IFilterOption[]>(() => {
  if (!isHistoricalOptionsListEnabled.value) return [];

  const selectedType = props.filters[DerivativesFiltersTypes.Type].selected;
  const options = props.filters[DerivativesFiltersTypes.Date].available.filter(
    option => {
      if (
        option.value === DerivativesFiltersDateValues.Historical &&
        selectedType === DerivativesFiltersTypeValues.Options
      )
        return true;
      else if (option.value === DerivativesFiltersDateValues.Today) return true;
      return false;
    }
  );

  return options.map(formatFilterOption);
});
const typeOptions = computed(() =>
  props.filters[DerivativesFiltersTypes.Type].available.map(formatFilterOption)
);
const hasTypeOptions = computed(() => typeOptions.value.length > 0);

const isHistoricalOptionsListEnabled = computed(() => {
  return FeatureFlagsModule.isEnabled(
    FeatureFlags.ENABLE_HISTORICAL_OPTIONS_LIST
  );
});

const formatFilterOption = (option: StringFormatted): IFilterOption => ({
  value: option.value,
  label: option.formatted
});

const handleEmitOnFilterChange = (
  filterKey: DerivativesFiltersTypes,
  filterValue?: DerivativesFiltersTypeValues | DerivativesFiltersDateValues
) => {
  emits('on-filter-change', filterKey, filterValue);
};

return { __sfc: true,props, emits, dateOptions, typeOptions, hasTypeOptions, isHistoricalOptionsListEnabled, formatFilterOption, handleEmitOnFilterChange, Heading, FilterOption, BaseText, FilterSelect, HeaderFilterLoader, HeaderSubtitleLoader, NebraskaColors, DerivativesFiltersTypes }
}

})